import { Autocomplete } from '@zoom/react-ui'
import { Option, OptionEvent } from './FilePermissions'

type FormDropdownProps = {
  options: Option[] // Must have length
  defaultOptionIndex?: number // Set the option shown on first render
  onChange: (e: OptionEvent) => void // Pass this from parent to handle user selection
  onKeyDown?: (e: React.KeyboardEvent) => void // This field in autocomplete defaults to the below prevent default
}

const preventDefaultFunc = (e: React.KeyboardEvent): void => {
  // Prevents user key strokes/ text entry but still allows tab
  if (e.key !== 'Tab') {
    e.preventDefault()
  }
}

const FormDropdown = ({
  options,
  defaultOptionIndex = 0,
  onChange,
  onKeyDown = preventDefaultFunc,
}: FormDropdownProps) => {
  const defaultPermissionsOption = options[defaultOptionIndex]
  const isOptionEqualToValue = (option: Option, value: Option) => {
    const isEqual = Boolean(
      option.label === value.label &&
        option.value === value.value &&
        option.verb === value.verb
    )
    return isEqual
  }

  return (
    <Autocomplete
      id='normalize-input'
      onChange={onChange}
      options={options}
      onKeyDown={onKeyDown}
      aria-label='Permissions type'
      defaultValue={defaultPermissionsOption}
      className='pointer-events-auto w-[130px] select-none pb-1.5 pl-1.5 pt-1.5 text-base caret-transparent'
      sx={{
        '.MuiOutlinedInput-root': {
          cursor: 'pointer !important',
        },
        '.MuiOutlinedInput-root fieldset': {
          border: 'none',
        },
        '#normalize-input': {
          /* Fails when applied directly */
          cursor: 'pointer !important',
        },
        '#normalize-input::selection': {
          /* Not supported by tailwind */
          background: 'transparent' /* Makes the text highlight transparent */,
          color: 'inherit' /* Keeps the text color unchanged */,
        },
      }}
      inputProps={{ style: { pointerEvents: 'all' } }}
      isOptionEqualToValue={isOptionEqualToValue}
    />
  )
}

export default FormDropdown
